// Purpose: Capture private sponsor/vendor credentials before React and analytics.
// Dependencies: Browser location/history only; no persistent browser storage.
// Behavior: Remove even malformed tokens and keep each family scoped to its event/record.
const invitations = new Map();
const FAMILIES = {
  sponsor: { fragment: "sponsorReview", route: "sponsor_verification" },
  vendor: { fragment: "vendorReview", route: "vendor_verification" },
};

export function captureBusinessVerificationInvite(family) {
  const config = FAMILIES[family];
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  if (!fragment.has(config.fragment)) return;
  const token = fragment.get(config.fragment);
  fragment.delete(config.fragment);
  const remainder = fragment.toString();
  window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}${remainder ? `#${remainder}` : ""}`);
  invitations.delete(family);
  const match = new RegExp(`^/([^/]+)/${config.route}/([^/]+)/?$`).exec(window.location.pathname);
  if (!match || !/^[a-f0-9]{64}$/.test(token || "")) return;
  try {
    const eventslug = decodeURIComponent(match[1]);
    const recordId = decodeURIComponent(match[2]);
    if ([eventslug, recordId].some((value) => !value || value.includes("/") || value.length > 200 || [".", ".."].includes(value))) return;
    invitations.set(family, { eventslug, recordId, token });
  } catch {
    // Malformed paths must never authorize another business record.
  }
}

export function getBusinessVerificationInvite(family, eventslug, recordId) {
  const invitation = invitations.get(family);
  return invitation?.eventslug === eventslug && invitation?.recordId === recordId ? invitation.token : "";
}
